/** UI texts of the web client (German). Legacy business texts come from /api/v2/i18n (LANG/ILANG). */
export default {
  app: {
    name: 'Creator',
    loading: 'Lädt …',
    retry: 'Erneut versuchen',
    close: 'Schließen',
    cancel: 'Abbrechen',
    ok: 'OK',
    save: 'Speichern',
    back: 'Zurück',
    menu: 'Menü',
    offline: 'Keine Verbindung – Änderungen werden erst nach dem Wiederverbinden angezeigt.',
    updateAvailable: 'Eine neue Version ist verfügbar.',
    updateReload: 'Neu laden',
    skipToContent: 'Zum Inhalt springen',
  },
  nav: {
    home: 'Start',
    navigation: 'Navigation',
    database: 'Datenbank',
    filter: 'Tabellen filtern',
    noMatch: 'Keine Tabelle gefunden',
    favorites: 'Favoriten',
    recent: 'Zuletzt genutzt',
    other: 'Sonstige',
    pin: 'Seitenleiste anheften',
    unpin: 'Seitenleiste ausblenden',
    toggleSidebar: 'Seitenleiste ein/aus',
    breadcrumb: 'Pfad',
    addFavorite: 'Zu Favoriten hinzufügen',
    removeFavorite: 'Aus Favoriten entfernen',
  },
  user: {
    printLayouts: 'Druck-Layouts',
    menu: 'Benutzermenü',
    language: 'Sprache',
    colorScheme: 'Farbschema',
    colorTheme: 'Farbthema',
    settings: 'Einstellungen',
    password: 'Passwort ändern',
    twoFactor: 'Zwei-Faktor-Anmeldung',
    twoFactorOn: 'aktiv',
    switchUser: 'Benutzer wechseln',
    switchUserPrompt: 'Als welcher Benutzer möchten Sie arbeiten?',
    switchBack: 'Zurück zu {user}',
    logout: 'Abmelden',
    shortcuts: 'Tastenkürzel',
    impersonating: 'Angemeldet als {user} durch {admin}.',
  },
  scheme: { auto: 'Automatisch', light: 'Hell', dark: 'Dunkel' },
  theme: {
    default: 'Standard',
    blue: 'Blau',
    green: 'Grün',
    grey: 'Grau',
    orange: 'Orange',
    petrol: 'Petrol',
    red: 'Rot',
    sportsman: 'Sportsman',
    yellow: 'Gelb',
  },
  lang: { de: 'Deutsch', en: 'English', fr: 'Français', nl: 'Nederlands', auto: 'Browser-Sprache' },
  login: {
    title: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    submit: 'Anmelden',
    totpTitle: 'Bestätigungscode',
    totpHint: 'Geben Sie den Code aus Ihrer Authenticator-App oder einen Backup-Code ein.',
    totp: 'Code',
    actAs: 'Starten als Benutzer (nur Admins)',
    invalid: 'Benutzername oder Passwort ist falsch.',
    totpInvalid: 'Der Code ist ungültig.',
    throttled: 'Zu viele Versuche. Bitte warten Sie {seconds} Sekunden.',
    throttledShort: 'Zu viele Versuche. Bitte später erneut versuchen.',
    unavailable: 'Die Anmeldung ist derzeit nicht verfügbar.',
    expired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
  },
  home: {
    title: 'Übersicht',
    databases: 'Datenbanken',
    empty: 'Keine Tabellen verfügbar.',
    tables: '{n} Tabellen',
  },
  table: {
    rows: 'Datensätze',
    placeholder: 'Vorläufige Ansicht – die vollständige Tabellenansicht folgt.',
    empty: 'Keine Datensätze.',
    new: 'Neu',
    refresh: 'Aktualisieren',
    of: 'von',
    live: 'Live-Aktualisierung aktiv',
  },
  record: {
    title: 'Datensatz {id}',
    new: 'Neuer Datensatz',
    prev: 'Vorheriger Datensatz',
    next: 'Nächster Datensatz',
    readonly: 'nur lesen',
  },
  account: {
    title: 'Konto',
    settings: 'Einstellungen',
    password: 'Passwort',
    security: 'Zwei-Faktor-Anmeldung',
    saved: 'Gespeichert.',
    localOnly: 'Die Einstellungen werden derzeit nur auf diesem Gerät gespeichert.',
    sectionDisplay: 'Darstellung',
    sectionTables: 'Tabellen und Datensätze',
    reset: 'Zurücksetzen',
    resetDefault: 'Auf Standard zurücksetzen',
    showUrl: 'Datensätze öffnen',
    showUrlOverlay: 'Als Overlay über der Tabelle',
    showUrlTab: 'In neuem Tab',
    showUrlPage: 'Als eigene Seite',
    margin: 'Zellabstand',
    marginNone: 'Kein',
    marginLow: 'Gering',
    marginMedium: 'Mittel',
    marginHigh: 'Groß',
    textSearch: 'Suchzeile in Tabellen',
    textSearchNever: 'Nie anzeigen',
    textSearchAlways: 'Immer anzeigen',
    textSearchFilter: 'Nur bei aktivem Filter anzeigen',
    fixedHeader: 'Tabellenkopf fixieren',
    sidebarPinned: 'Seitenleiste angeheftet (Desktop)',
    pageSize: 'Datensätze pro Seite',
    pageSizeDefault: 'Standard der Tabelle',
    help: {
      lang: 'Sprache der Oberfläche. „Browser-Sprache“ folgt der Einstellung Ihres Browsers.',
      colorScheme: 'Hell, dunkel oder automatisch nach der Einstellung des Geräts.',
      theme: 'Akzentfarben von Kopfzeile, Seitenleiste und Schaltflächen.',
      margin: 'Abstand innerhalb der Tabellenzellen – kleiner zeigt mehr Zeilen auf einmal.',
      sidebarPinned: 'Die Seitenleiste bleibt auf großen Bildschirmen dauerhaft sichtbar.',
      showUrlOverlay: 'Öffnet den Datensatz in einem großen Fenster über der Tabelle (mobil im Vollbild); die Tabelle bleibt erhalten.',
      showUrlTab: 'Öffnet jeden Datensatz in einem neuen Browser-Tab.',
      showUrlPage: 'Ersetzt die Tabelle durch den Datensatz; „Zurück“ führt zur Tabelle.',
      textSearch: 'Zeile mit Suchfeldern unter dem Tabellenkopf. „Nur bei aktivem Filter“ blendet sie ein, sobald ein Filter gesetzt ist.',
      fixedHeader: 'Der Tabellenkopf bleibt beim Scrollen sichtbar.',
      pageSize: 'Wie viele Datensätze eine Tabelle pro Seite lädt.',
      shortcuts: 'Klicken Sie auf +, und drücken Sie die gewünschte Tastenkombination (Esc bricht ab). Eigene Belegungen werden in Ihrem Konto gespeichert.',
    },
    scope_global: 'Überall',
    scope_table: 'Tabelle',
    scope_record: 'Datensatz',
    shortcutCustom: 'angepasst',
    shortcutNone: 'keine',
    shortcutAdd: 'Tastenkombination hinzufügen',
    shortcutRemove: '{key} entfernen',
    shortcutPress: 'Tasten drücken …',
    shortcutRecording: 'Aufnahme: drücken Sie die neue Tastenkombination, Esc bricht ab',
    shortcutReserved: 'Diese Kombination ist dem Browser vorbehalten.',
    shortcutPlain: 'Die Leertaste allein kann nicht belegt werden.',
    shortcutTooMany: 'Zu viele Tastenkombinationen für diese Aktion.',
    shortcutConflictTitle: 'Tastenkombination bereits belegt',
    shortcutConflict: '{key} ist bereits belegt mit: {actions}. Dort entfernen und hier zuweisen?',
    shortcutReassign: 'Neu zuweisen',
    shortcutConflicts: 'Mehrfach belegte Tastenkombinationen:',
    shortcutResetAll: 'Alle zurücksetzen',
    shortcutResetAllConfirm: 'Alle Tastenkürzel auf die Standardbelegung zurücksetzen?',
    shortcutResetDone: 'Die Tastenkürzel wurden zurückgesetzt.',
    oldPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    repeatPassword: 'Neues Passwort wiederholen',
    changePassword: 'Passwort ändern',
    showPasswords: 'Passwörter anzeigen',
    passwordMismatch: 'Die Passwörter stimmen nicht überein.',
    passwordChanged: 'Das Passwort wurde geändert. Andere Sitzungen wurden beendet.',
    passwordRules: 'Mindestens {min} Zeichen, nicht gleich dem Benutzernamen.',
    passwordSessionsHint: 'Nach der Änderung werden Ihre anderen Sitzungen (andere Geräte, Browser) abgemeldet.',
    oldPasswordWrong: 'Das aktuelle Passwort ist falsch.',
    passwordWeak: 'Das neue Passwort erfüllt die Regeln nicht (mindestens {min} Zeichen, nicht gleich dem Benutzernamen).',
    passwordExternal: 'Das Passwort dieses Kontos wird extern verwaltet (z. B. LDAP) und kann hier nicht geändert werden.',
    pwStrength: 'Passwortstärke',
    pwScore0: 'Zu schwach',
    pwScore1: 'Schwach',
    pwScore2: 'Mittel',
    pwScore3: 'Gut',
    pwScore4: 'Sehr gut',
    pwHint: {
      tooShort: 'mindestens {min} Zeichen',
      username: 'nicht gleich dem Benutzernamen',
      tooLong: 'zu lang',
      mix: 'Groß-/Kleinbuchstaben, Ziffern und Sonderzeichen mischen',
      repeat: 'Wiederholungen und Folgen vermeiden',
      common: 'zu gebräuchlich',
      longer: 'länger ist sicherer',
      sameAsOld: 'gleich dem aktuellen Passwort',
    },
    totpEnabled: 'Die Zwei-Faktor-Anmeldung ist aktiv.',
    totpDisabled: 'Die Zwei-Faktor-Anmeldung ist nicht aktiv.',
    totpIntro: 'Bei der Anmeldung wird zusätzlich ein Code aus einer Authenticator-App (z. B. FreeOTP, Google Authenticator, Microsoft Authenticator) abgefragt.',
    totpUnavailable: 'Die Zwei-Faktor-Anmeldung ist auf diesem Server nicht eingerichtet.',
    totpStart: 'Einrichten',
    totpStep1: 'Scannen Sie den QR-Code mit Ihrer Authenticator-App oder geben Sie den Schlüssel von Hand ein.',
    totpStep2: 'Geben Sie zur Bestätigung den Code ein, den die App anzeigt.',
    totpQr: 'QR-Code für die Authenticator-App',
    totpSecret: 'Schlüssel für die Authenticator-App',
    totpAccount: 'Konto',
    totpManualHint: 'Zeitbasiert (TOTP), 6 Ziffern, 30 Sekunden.',
    totpLink: 'In Authenticator-App öffnen',
    totpVerify: 'Bestätigen',
    totpCode: 'Code aus der App',
    totpCodeOrBackup: 'Code aus der App oder Backup-Code',
    totpBackupTitle: 'Backup-Codes',
    totpBackup: 'Bewahren Sie diese Codes jetzt sicher auf – sie werden nur einmal angezeigt. Jeder Code ersetzt einmal den Code aus der App, z. B. wenn das Telefon verloren geht.',
    totpBackupSaved: 'Ich habe die Backup-Codes sicher gespeichert.',
    copy: 'Kopieren',
    download: 'Als Textdatei herunterladen',
    secretCopied: 'Schlüssel kopiert.',
    codesCopied: 'Backup-Codes kopiert.',
    copyFailed: 'Kopieren nicht möglich – bitte von Hand markieren.',
    done: 'Fertig',
    totpDisable: 'Abschalten',
    totpDisableHint: 'Zum Abschalten sind Passwort und ein aktueller Code (oder Backup-Code) nötig.',
    totpDisableConfirm: 'Zwei-Faktor-Anmeldung wirklich abschalten? Ihr Konto ist danach nur noch durch das Passwort geschützt.',
    totpDisableWrong: 'Passwort oder Code ist falsch.',
    totpDisabledDone: 'Die Zwei-Faktor-Anmeldung wurde abgeschaltet.',
  },
  error: {
    generic: 'Es ist ein Fehler aufgetreten.',
    network: 'Der Server ist nicht erreichbar.',
    forbidden: 'Keine Berechtigung.',
    notFound: 'Nicht gefunden.',
    conflict: 'Konflikt mit dem aktuellen Stand.',
    stale: 'Der Datensatz wurde inzwischen von jemand anderem geändert.',
    validation: 'Bitte prüfen Sie die Eingaben.',
    locked: 'Der Datensatz wird gerade bearbeitet.',
    lockedBy: 'Der Datensatz wird gerade von {user} bearbeitet.',
    rateLimited: 'Zu viele Anfragen. Bitte warten Sie einen Moment.',
    server: 'Serverfehler. Bitte versuchen Sie es später erneut.',
    pending: 'Diese Ansicht ist noch nicht verfügbar.',
    pendingCompare: 'Der Vergleich zweier Datensätze folgt in einer der nächsten Versionen.',
    pendingForm: 'Dieses Formular des Altsystems ist noch nicht übernommen.',
    notFoundPage: 'Diese Seite gibt es nicht.',
    toHome: 'Zur Startseite',
  },
  shortcuts: {
    title: 'Tastenkürzel',
    app_search: 'Suche / Tabellenfilter',
    app_toggleSidebar: 'Seitenleiste ein/aus',
    app_help: 'Tastenkürzel anzeigen',
    table_next: 'Nächste Zeile',
    table_prev: 'Vorherige Zeile',
    table_open: 'Zeile öffnen',
    table_new: 'Neuer Datensatz',
    table_delete: 'Zeile löschen',
    table_refresh: 'Tabelle aktualisieren',
    record_save: 'Speichern',
    record_saveClose: 'Speichern und schließen',
    record_close: 'Schließen',
    record_next: 'Nächster Datensatz',
    record_prev: 'Vorheriger Datensatz',
    record_pageNext: 'Nächste Seite des Formulars',
    record_pagePrev: 'Vorige Seite des Formulars',
    browserNote: 'Strg+Tab und Strg+Umschalt+Tab wechseln in den meisten Browsern den Tab und kommen nicht bei der Anwendung an. Für die Formularseiten nutzen Sie deshalb Strg+Alt+→ und Strg+Alt+←.',
  },
  dev: { elements: 'Form-Elemente (Entwicklung)' },
};
